export const EVENT_WORKSPACE_SETTINGS_JOB_SUBTYPES_SAVED =
  'manage-job-subtypes-saved';
export const EVENT_WORKSPACE_SETTINGS_JOB_SUBTYPE_ADDED =
  'admin-job-subtype-added';
export const EVENT_WORKSPACE_SETTINGS_JOB_SUBTYPE_EDITED =
  'admin-job-subtype-edited';
export const EVENT_WORKSPACE_SETTINGS_JOB_SUBTYPE_DELETED =
  'admin-job-subtype-deleted';
